import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "q-ml-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_ctx.isGranted('VIEW_LABELS'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_btn_group, { rounded: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "far fa-lightbulb",
              color: _ctx.total ? 'primary' : undefined,
              "text-color": _ctx.total ? 'white' : undefined,
              class: "q-py-sm",
              onClick: _ctx.openLabelFilter
            }, {
              default: _withCtx(() => [
                (_ctx.total)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.total), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Filter by Insights")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["color", "text-color", "onClick"]),
            (_ctx.total)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  icon: "fa fa-times",
                  class: "q-py-sm",
                  onClick: _ctx.clear
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Clear label filter")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}